import { cn } from '@divlab/divanui';

import useMedias from '@Hooks/useMedias';
import ListItem from './elements/ListItem';
import Video from '@Components/Video';
import styles from './QualityLaboratory.module.css';

import type { FC, HTMLAttributes } from 'react';

interface List {
  title: string;
  description: string;
}
export interface QualityLaboratoryProps extends HTMLAttributes<HTMLDivElement> {
  description: string;
  list: List[];
  video: string;
  title: string;
}

const QualityLaboratory: FC<QualityLaboratoryProps> = (props) => {
  const { description, list, video, className, title, ...restProps } = props;
  const { isDesktop } = useMedias();

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      {isDesktop && <div className={styles.title}>{title}</div>}
      <div className={styles.topContainer}>
        <div className={styles.videoContainer}>
          <Video src={video} className={styles.video} autoPlay loop />
        </div>
        <div>
          {!isDesktop && <div className={styles.title}>{title}</div>}
          <div className={styles.description}>{description}</div>
        </div>
      </div>

      <div className={styles.list}>
        {list.map((item, index) => (
          <ListItem
            key={item.title}
            title={item.title}
            description={item.description}
            number={index + 1}
          />
        ))}
      </div>
    </div>
  );
};

export default QualityLaboratory;
